import styled from "styled-components";

export const ActionsContainer = styled.div`
  --primary-color: #dbaa0c;
  --secondary-color: #0c456a;
  --primary-color-opaque: #dbaa0c77;
  --secondary-color-opaque: #0c456a77;

  height: auto;
  min-height: 100%;
  background-color: #f7f9fc;
`;
